var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCameraWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.60427 4.125H10.9137C13.1338 4.125 14.6839 5.65495 14.6839 7.8475V14.1525C14.6839 16.3451 13.1338 17.875 10.9137 17.875H5.60427C3.38408 17.875 1.83398 16.3451 1.83398 14.1525V7.8475C1.83398 5.65495 3.38408 4.125 5.60427 4.125ZM18.2955 6.30574C18.6979 6.101 19.17 6.1224 19.5541 6.36437C19.9381 6.6054 20.1673 7.02418 20.1673 7.48205V14.5185C20.1673 14.9773 19.9381 15.3952 19.5541 15.6362C19.3441 15.7674 19.1095 15.8344 18.873 15.8344C18.6759 15.8344 18.4788 15.7879 18.2945 15.6939L16.937 15.009C16.4346 14.754 16.1229 14.2421 16.1229 13.6735V8.32613C16.1229 7.75658 16.4346 7.24474 16.937 6.99161L18.2955 6.30574Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraWhite);
export default __webpack_public_path__ + "static/media/cameraWhite.e3828e08.svg";
export { ForwardRef as ReactComponent };